// JOBE-0098.3: collapsed `searchtrigger` bar. Click → opens the
// palette. The faint AI-purple stripe on the left edge surfaces that
// this is a search + ask surface even when collapsed (JOBE-0098 §State 1).

import { forwardRef } from 'react';

const PLACEHOLDER_BY_VARIANT = {
  library: 'Find or ask…  ⌘,',
  'entity-scoped': 'Ask this entity — summarise · diff vs yesterday',
  free: 'Find…',
};

export const SearchTrigger = forwardRef(function SearchTrigger(
  { placeholderVariant = 'library', onOpen },
  ref,
) {
  const placeholder = PLACEHOLDER_BY_VARIANT[placeholderVariant] || PLACEHOLDER_BY_VARIANT.library;
  return (
    <button
      ref={ref}
      type="button"
      className="omni-searchtrigger"
      onClick={onOpen}
      aria-label="Open find or ask palette"
      data-variant={placeholderVariant}
    >
      <span className="omni-searchtrigger-stripe" aria-hidden="true" />
      <span className="omni-searchtrigger-icon" aria-hidden="true">⌕</span>
      <span className="omni-searchtrigger-placeholder">{placeholder}</span>
    </button>
  );
});
